const APP_DESCRIPTION =
  "Track Every Practice Rep. Eliminate Manual Data Entry."

export { APP_DESCRIPTION }
